import { useEffect } from 'react';
import { useAppDispatch } from '../../Hooks/Hooks';
import { getContentStackData } from '../../Redux/Reducers/ContentOrConfigSlice';
import { TFeedbackProps } from './Feedback.type';
import FeedbackComponent from '../../Components/Shared/FeedbackComponent/FeedbackComponent';
import './Feedback.scss';

const Feedback = (props: TFeedbackProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getContentStackData({ queryPayload: { contentType: 'feedback_content' } }));
  }, [dispatch]);

  return (
    <div className="Feedback">
      <p>Feedback</p>
      <FeedbackComponent />
    </div>
  );
};

export default Feedback;
